'use client'

import { IconClose } from '@/components/icons/icon-close'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { LocalStorage } from '@/lib/utils/local-storage'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { CoolClubInfoModal } from './coolclub-info'

export const StickyCoolClub = () => {
  const [isShow, setIsShow] = useState(!LocalStorage.get('STICKY_COOLCLUB'))
  const [openInfoModal, setOpenInfoModal] = useState(false)

  const currentPath = usePathname()
  const EXCLUDE_PATHS = ['/cart', '/nhan-qua-coolclub']
  // const isFriday = dayjs().day() === 5

  const isFriday = false

  if (!isShow || EXCLUDE_PATHS.includes(currentPath) || !isFriday) return

  return (
    <>
      <div className='fixed bottom-[7.75rem] left-4 z-[9] w-32 cursor-pointer md:bottom-[8.5rem] md:w-36'>
        {/* //close btn  */}
        <Button
          variant={'white'}
          onClick={() => {
            setIsShow(false)
            LocalStorage.set('STICKY_COOLCLUB', true)
          }}
          className='absolute -right-2 top-0 h-5 w-5 border border-white bg-black p-0 text-white'
          aria-label='Close sticky setting'
        >
          <IconClose className={cn('!h-2 !w-2')} />
        </Button>
        <Image
          src={ImageHelper.getImageUrl('/image/April2024/mceclip1_100.png')}
          alt='Sticky setting'
          width={500}
          height={500}
          className='w-full'
          onClick={() => setOpenInfoModal(true)}
        />
      </div>
      <CoolClubInfoModal open={openInfoModal} onOpenChange={setOpenInfoModal} />
    </>
  )
}
